/**
 * The query parameter naming the section of a page someone jumped to from the rail, so the url
 * they copy lands the next reader on the same card: `/people/:id/profile?section=care-team`.
 */
export const PAGE_ANCHOR_QUERY_PARAM = 'section';
